import Vue from 'vue'
import App from './App.vue'
import './services/codefabrik-ui/codefabrik-ui'
import router from './services/vuerouter/vueRouter'
import i18n from './services/vuei18n/vueI18n'
import './filters/duration'
import './filters/localDateTime'
import './filters/weekDay'
import './filters/currency'
import './filters/number'
import './filters/week'
import store, { MUTATIONS } from './store'
import './services/echarts/echarts'
import './assets/styles/index.css'
import './services/vee-validate/vee-validate'
import { connectDesktopApp } from './services/desktopApp/desktopApp'

Vue.config.productionTip = false
window.Vue = Vue

new Vue({
  render: h => h(App),
  router,
  i18n,
  store
}).$mount('#app')

connectDesktopApp()

// Lets browsers install ZeitFabrik as an app
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => navigator.serviceWorker.register('/sw.js'))
}
